import { FrontendPortal } from "@vega-api/generated/types/frontendPortal";
import { VEGA_ID } from "@vega-core/constants/global";
import { useTheme } from "@vega-core/context/ThemeContext/ThemeContext";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { m } from "@vega-core/paraglide/messages";

export const AuthHeader = ({ portal }: { portal: FrontendPortal }) => {
  const {
    global: { companyId, companyName },
    theme: { logos },
  } = usePublicConfig();
  const { theme } = useTheme();

  return (
    <header className="h-11 flex items-center justify-between lg:mb-6">
      <div className="flex items-center h-5">
        <div className="shadow-card sm:shadow-none h-10 w-10 sm:h-auto sm:w-auto sm:p-0 flex items-center justify-center rounded-lg">
          {companyId === VEGA_ID ? (
            <picture>
              <source
                media="(max-width: 840px)"
                srcSet={logos.smallLogoLight}
              />
              <img
                alt="vega"
                className="w-auto h-16 lg:mb-6"
                src={logos.logoLight}
              />
            </picture>
          ) : (
            <picture className="h-5 w-5 sm:h-auto sm:w-auto">
              <source
                media="(max-width: 840px)"
                srcSet={
                  theme === "light" ? logos.smallLogoLight : logos.smallLogoDark
                }
              />
              <img
                alt={companyName}
                className="sm:w-auto sm:h-5 mx-auto *:"
                src={theme === "light" ? logos.logoLight : logos.logoDark}
              />
            </picture>
          )}
        </div>
        <div className="border-r-1 border-border/primary w-0.5 h-full ml-4 mr-4" />
        <div className="text-text/secondary  body-large-regular">
          {portal === FrontendPortal.GP_PORTAL
            ? m.titles_workbench()
            : m.auth_loginHeaderTitle()}
        </div>
      </div>
    </header>
  );
};
